// extracted by mini-css-extract-plugin
export var error = "error-module--error--lJ5PT";